import { feedback } from '~/components/review/stars';
import Lightbox from 'react-image-lightbox';
import { RateSmallIcon } from '~/svgs/common';
import Image from 'next/image';
import { DateTime } from 'luxon';
import { Swiper, SwiperSlide } from 'swiper/react';
import { memo, useState } from 'react';
import { Translate, useTranslate } from '~/i18n';
type SingleReviewProps = {
   user: any;
   liked_comment: string;
   not_liked_comment: string;
   photos: string[];
   created_at: string;
   reply: any;
} & { [key: string]: any };

export const SingleReview = memo(
   ({
      experience_rating: rating,
      user,
      liked_comment,
      not_liked_comment,
      photos,
      created_at,
      reply,
   }: SingleReviewProps) => {
      const { dir } = useTranslate();

      const [lightboxImage, setLightBoxImage] = useState({
         open: false,
         index: 0,
      });

      return (
         <div className="p-3 pb-1 mb-0 bg-white">
            <div className="flex items-center justify-between">
               <div className="flex flex-wrap items-start">
                  {user.thumbnail ? (
                     <div className="ltr:mr-3 rtl:ml-3">
                        <Image
                           width={32}
                           height={32}
                           src={user.thumbnail}
                           className="flex-shrink-0 object-cover overflow-hidden rounded-full"
                        />
                     </div>
                  ) : (
                     <div className="flex-shrink-0 w-8 h-8 overflow-hidden rounded-full bg-primary-light ltr:mr-3 rtl:ml-3"></div>
                  )}
                  <div>
                     <div className="break-words text-primary-focus">{user.name}</div>
                     <div className="text-xs break-words opacity-70 text-primary-focus">
                        {DateTime.fromJSDate(new Date(created_at)).toFormat('dd LLLL yyyy')}
                     </div>
                  </div>
               </div>
               <div>
                  <div className="flex items-center space-x-1 rtl:space-x-reverse">
                     {[...new Array(5)].map((_, idx) => (
                        <RateSmallIcon
                           key={idx}
                           style={{ color: Math.ceil(rating) >= idx + 1 ? '#FD7E14' : '#CED4DA' }}
                        />
                     ))}
                  </div>
                  <div className="text-sm rtl:text-left ltr:text-right">
                     {feedback[Math.ceil(rating)]}
                  </div>
               </div>
            </div>
            <div className="mt-4 text-primary-focus">
               {liked_comment ? (
                  <div className="mb-4">
                     <div className="text-[15px] text-[#ADB5BD]">
                        <Translate id="common:what is liked" />
                     </div>
                     <p className="text-[15px] text-primary-color">{liked_comment}</p>
                  </div>
               ) : null}
               {not_liked_comment ? (
                  <div className="mb-4">
                     <div className="text-[15px] text-[#ADB5BD]">
                        {' '}
                        <Translate id="common:what is not liked" />
                     </div>
                     <p className="text-[15px] text-primary-color">{not_liked_comment}</p>
                  </div>
               ) : null}
               {reply ? (
                  <div className="flex flex-row p-2 my-4 border-t bg-gray-light rounded-default">
                     <div>
                        {reply?.organizer_thumbnail ? (
                           <Image
                              width={23}
                              height={23}
                              src={reply?.organizer_thumbnail}
                              quality={100}
                              className="flex-shrink-0 object-cover overflow-hidden rounded-full"
                           />
                        ) : (
                           <div className="flex-shrink-0 object-cover w-5 h-5 overflow-hidden bg-gray-300 rounded-full"></div>
                        )}
                     </div>
                     <div className="mx-2 mb-2 text-base break-words text-primary-color">
                        <div className="font-medium">{reply?.created_by}</div>
                        <div className="mt-2 font-light tablet:font-normal">{reply?.content}</div>
                     </div>
                  </div>
               ) : null}
               {photos?.length && lightboxImage.open ? (
                  <div>
                     <Lightbox
                        wrapperClassName="is-rtl"
                        onCloseRequest={() => setLightBoxImage(prev => ({ ...prev, open: false }))}
                        prevSrc={photos[(lightboxImage.index - 1) % photos.length]}
                        nextSrc={photos[(lightboxImage.index + 1) % photos.length]}
                        mainSrc={photos[lightboxImage.index]}
                        onMoveNextRequest={() =>
                           setLightBoxImage(prev => ({
                              ...prev,
                              index: (prev.index + 1) % photos.length,
                           }))
                        }
                        onMovePrevRequest={() =>
                           setLightBoxImage(prev => ({
                              ...prev,
                              index: (prev.index - 1) % photos.length,
                           }))
                        }
                     />
                  </div>
               ) : null}

               {photos.length ? (
                  <Swiper
                     className="mb-4"
                     key={`${dir}-images`}
                     dir={dir}
                     slidesPerView="auto"
                     spaceBetween={10}>
                     {photos.map((photo, index) => (
                        <SwiperSlide style={{ width: 136 }} key={index}>
                           <Image
                              width={136}
                              height={91}
                              className="object-cover rounded cursor-pointer"
                              onClick={() => setLightBoxImage({ index, open: true })}
                              src={photo}
                           />
                        </SwiperSlide>
                     ))}
                  </Swiper>
               ) : null}
            </div>
            {/* <hr className="mt-2" /> */}
         </div>
      );
   }
);
SingleReview.displayName = 'SingleReview';
